<template>

	<div class="screen-container" :style="containerStyle">


		<header class="screen-header">
			<div>
				<img src="/static/img/header_border_dark.png" alt="">
				<!-- <img :src="headerSrc" alt=""> -->
			</div>
			<span class="logo">
				<!-- <img src="/static/img/logo_dark.png" alt="" /> -->
			</span>
			<span class="title">协同办公平台实时监控系统</span>
			<div class="title-right">
				<img src="/static/img/qiehuan_dark.png" class="qiehuan">
				<!-- <img :src="themeSrc" class="qiehuan" @click="handleChangeTheme"> -->
				<span class="datetime">2049-01-01 00:00:00</span>
			</div>
		</header>


		<div class="screen-body">

			<section class="screen-left">
				<!-- 销量趋势图表 -->
				<div id="left-top"  :class="[fullScreenStatus.trend ? 'fullscreen' : '']">
					<Trend ref="trend"></Trend>
					<div class="resize">
						<span @click="changeSize('trend')" :class="['iconfont', fullScreenStatus.trend ? 'icon-compress-alt' : 'icon-expand-alt']"></span>
					</div>
				</div>
				<!-- 商家销售金额图表 -->
				<div id="left-bottom" :class="fullscreen">
					<!-- <div id="left-bottom" :class="[fullScreenStatus.seller ? 'fullscreen' : '']"> -->
					<Seller ref="seller"></Seller>
					<div class="resize">
						<span @click="changeSize('seller')"
							:class="['iconfont', fullScreenStatus.seller ? 'icon-compress-alt' : 'icon-expand-alt']"></span>
					</div>
				</div>
			</section>


			<section class="screen-middle">
				<!-- 商家分布图表 -->
				<div id="middle-top">
					<!-- <div id="middle-top" :class="[fullScreenStatus.map ? 'fullscreen' : '']"> -->
					<Map ref="map"></Map>
					<div class="resize">
						<span @click="changeSize('map')"
							:class="['iconfont', fullScreenStatus.map ? 'icon-compress-alt' : 'icon-expand-alt']"></span>
					</div>
				</div>

				<!-- 地区销量排行图表 -->
				<div id="middle-bottom">
					<!-- <div id="middle-bottom" :class="[fullScreenStatus.rank ? 'fullscreen' : '']"> -->
					<Rank ref="rank"></Rank>
					<div class="resize">
						<span @click="changeSize('rank')"
							:class="['iconfont', fullScreenStatus.rank ? 'icon-compress-alt' : 'icon-expand-alt']"></span>
					</div>
				</div>
			</section>




			<section class="screen-right">
				<!-- 热销商品占比图表 -->
				<div id="right-top">
				<!-- <div id="right-top" :class="[fullScreenStatus.hot ? 'fullscreen' : '']"> -->
					<Hot ref="hot"></Hot>
					<div class="resize">
						<span @click="changeSize('hot')"
							:class="['iconfont', fullScreenStatus.hot ? 'icon-compress-alt' : 'icon-expand-alt']"></span>
					</div>
				</div>
				<!-- 库存销量分析图表 -->
				<div id="right-bottom">
				<!-- <div id="right-bottom" :class="[fullScreenStatus.stock ? 'fullscreen' : '']"> -->
					<Stock ref="stock"></Stock>
					<div class="resize">
						<span @click="changeSize('stock')"
							:class="['iconfont', fullScreenStatus.stock ? 'icon-compress-alt' : 'icon-expand-alt']"></span>
					</div>
				</div>
			</section>

		</div>



	</div>
</template>

<script>
	import Hot from '@/components/header/Hot.vue'
	import Map from '@/components/header/Map.vue'
	import Rank from '@/components/header/Rank.vue'
	import Seller from '@/components/header/Seller.vue'
	import Stock from '@/components/header/Stock.vue'
	import Trend from '@/components/header/Trend.vue'
	// import { mapState } from 'vuex'
	// import { getThemeValue } from '@/utils/theme_utils'
	export default {
		// created () {
		// 注册接收到数据的回调函数
		// this.$socket.registerCallBack('fullScreen', this.recvData)
		// this.$socket.registerCallBack('themeChange', this.recvThemeChange)
		// },
		// destroyed () {
		// this.$socket.unRegisterCallBack('fullScreen')
		// this.$socket.unRegisterCallBack('themeChange')
		// },
		data() {
			return {
				// 定义每一个图表的全屏状态
				fullScreenStatus: {
					trend: false,
					seller: false,
					map: false,
					rank: false,
					hot: false,
					stock: false
				}
			}
		},
		methods: {
			changeSize (chartName) {
			// 1.改变fullScreenStatus的数据
			this.fullScreenStatus[chartName] = !this.fullScreenStatus[chartName]
			// 2.需要调用每一个图表组件的screenAdapter的方法
			this.$refs[chartName].screenAdapter()
			this.$nextTick(() => {
			  this.$refs[chartName].screenAdapter()
			})
			// 将数据发送给服务端
			// const targetValue = !this.fullScreenStatus[chartName]
			// this.$socket.send({
			//   action: 'fullScreen',
			//   socketType: 'fullScreen',
			//   chartName: chartName,
			//   value: targetValue
			// })
			},
			// 接收到全屏数据之后的处理
			// recvData (data) {
			// 取出是哪一个图表需要进行切换
			// const chartName = data.chartName
			// 取出, 切换成什么状态
			// const targetValue = data.value
			// this.fullScreenStatus[chartName] = targetValue
			// this.$nextTick(() => {
			//   this.$refs[chartName].screenAdapter()
			// })
			// },
			handleChangeTheme() {
				// 修改VueX中数据
				// this.$store.commit('changeTheme')
				// this.$socket.send({
				//   action: 'themeChange',
				//   socketType: 'themeChange',
				//   chartName: '',
				//   value: ''
				// })
			},
			// recvThemeChange () {
			// this.$store.commit('changeTheme')
			// }
		},
		components: {
		  Hot,
		  Map,
		  Rank,
		  Seller,
		  Stock,
		  Trend
		},
		computed: {
			// logoSrc () {
			//   return '/static/img/' + getThemeValue(this.theme).logoSrc
			// },
			// headerSrc () {
			//   return '/static/img/' + getThemeValue(this.theme).headerBorderSrc
			// },
			// themeSrc () {
			//   return '/static/img/' + getThemeValue(this.theme).themeSrc
			// },
			// containerStyle () {
			//   return {
			//     backgroundColor: getThemeValue(this.theme).backgroundColor,
			//     color: getThemeValue(this.theme).titleColor
			//   }
			// },
			// ...mapState(['theme'])
		}
	}
</script>
<!--  <style lang="less" scoped> -->
<style>
	// 全屏样式的定义
.fullscreen {
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  width: 100% !important;
  height: 100% !important;
  margin: 0 !important;
  z-index: 100;
}
.screen-container {
  width: 100%;
  height: 100%;
  padding: 0 20px;
  background-color: #161522;
  color: #fff;
  box-sizing: border-box;
}
.screen-header {
  width: 100%;
  height: 64px;
  font-size: 20px;
  position: relative;
}
.screen-header > div img {
  width: 100%;
}
.screen-header .title {
  position: absolute;
  left: 50%;
  top: 50%;
  font-size: 20px;
  transform: translate(-50%,-50%);
}
.screen-header .title-right {
  display: flex;
  align-items: center;
  position: absolute;
  right: 0px;
  top: 50%;
  transform: translateY(-80%);
}
.screen-header .qiehuan {
  width: 28px;
  height: 21px;
  cursor: pointer;
}
.screen-header .datetime {
  font-size: 15px;
  margin-left: 10px;
}
.screen-header .logo {
  position: absolute;
  left: 0px;
  top: 50%;
  transform: translateY(-80%);
}
.screen-header .logo img {
  height: 35px;
  width: 128px;
}
.screen-body {
  width: 100%;
  height: 100%;
  display: flex;
  margin-top: 10px;
}
.screen-body .screen-left {
  height: 100%;
  width: 27.6%;
}
.screen-body .screen-left #left-top {
  height: 53%;
  position: relative;
}
.screen-body .screen-left #left-bottom {
  height: 31%;
  margin-top: 25px;
  position: relative;
}
.screen-body .screen-middle {
  height: 100%;
  width: 41.5%;
  margin-left: 1.6%;
  margin-right: 1.6%;
}
.screen-body .screen-middle #middle-top {
  width: 100%;
  height: 56%;
  position: relative;
}
.screen-body .screen-middle #middle-bottom {
  margin-top: 25px;
  width: 100%;
  height: 28%;
  position: relative;
}
.screen-body .screen-right {
  height: 100%;
  width: 27.6%;
}
.screen-body .screen-right #right-top {
  height: 46%;
  position: relative;
}
.screen-body .screen-right #right-bottom {
  height: 38%;
  margin-top: 25px;
  position: relative;
}
.resize {
  position: absolute;
  right: 20px;
  top: 20px;
  cursor: pointer;
}
	
	/* 边框难看 */
/* 	section > div {
		border: 1px solid red;
	} */
	
</style>
